import React from 'react';
import './Bo.css';

// Linh vật Bo (heo đất). Vẽ lại từ file thiết kế Bo.dc.html.
// mood: happy | laugh | wink | wow | love | sad
// pose: wave | phone | bag | cheer | present | none (present = tay đưa ra mời, dùng cạnh bong bóng thoại)
// facing: right | left (left = lật ngang để Bo nhìn vào nội dung bên trái)
// halo: pink | paper | sun (vòng tròn nền sau Bo, tuỳ chọn)
// announce: Bo báo tiền hoàn — bật lên với mặt ngạc nhiên rồi đổi sang `mood`, đồng xu bật khỏi khe.
//   Hoạt họa nằm trong Bo.css (.bo--announce), nên dùng cùng pose="present"
// faces: danh sách mood vẽ chồng, mỗi mặt một nhóm .bo-face--<mood> để CSS nơi dùng đổi mặt theo thời gian
//   (màn hình tải vẽ sẵn trong HTML, không có React để đổi mood). Có faces thì bỏ qua mood

const INK = '#5A0E16';
const BODY = '#F0414D';
const ARM_TIP = '#8A1220';
const FONT = "'Baloo 2', 'Be Vietnam Pro', sans-serif";

const MOOD_LABELS = {
  happy: 'vui vẻ',
  laugh: 'cười tít mắt',
  wink: 'nháy mắt',
  wow: 'ngạc nhiên',
  love: 'mê tít',
  sad: 'buồn'
};

const Arm = ({ transform }) => (
  <g transform={transform}>
    <path d="M0 -12 L44 -12 A12 12 0 0 1 44 12 L0 12 Z" fill={BODY} stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
    <path d="M38 -12 L44 -12 A12 12 0 0 1 44 12 L38 12 Z" fill={ARM_TIP} stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
  </g>
);

const Leg = ({ x }) => (
  <>
    <path d={`M${x} 226 L${x} 258 Q${x} 272 ${x + 17} 272 Q${x + 34} 272 ${x + 34} 258 L${x + 34} 226 Z`} fill="#E23545" stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
    <path d={`M${x} 256 Q${x} 272 ${x + 17} 272 Q${x + 34} 272 ${x + 34} 256 Z`} fill={ARM_TIP} stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
    <path d={`M${x + 17} 262 L${x + 17} 270`} stroke={INK} strokeWidth="3" strokeLinecap="round" />
  </>
);

const Coin = ({ cx, cy, r, big }) => (
  <>
    <circle cx={cx} cy={cy} r={r} fill="#FFC53D" stroke={INK} strokeWidth={big ? 3.5 : 3} />
    {big && <circle cx={cx} cy={cy} r={r - 5} fill="none" stroke="#F59F00" strokeWidth="2.5" />}
  </>
);

const Flower = () => (
  <>
    <path d="M88 208 Q70 198 64 213 Q76 220 88 208 Z" fill="#3FA34D" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    <path d="M88 208 Q104 222 96 236 Q82 224 88 208 Z" fill="#3FA34D" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    {[[88, 198], [97.5, 204.9], [93.9, 216.1], [82.1, 216.1], [78.5, 204.9]].map(([x, y]) => (
      <circle key={`o${x}`} cx={x} cy={y} r="8" fill="#FFD43B" stroke={INK} strokeWidth="5" />
    ))}
    {[[88, 198], [97.5, 204.9], [93.9, 216.1], [82.1, 216.1], [78.5, 204.9]].map(([x, y]) => (
      <circle key={`i${x}`} cx={x} cy={y} r="8" fill="#FFD43B" />
    ))}
    <circle cx="88" cy="208" r="5" fill="#F08C00" stroke={INK} strokeWidth="2" />
    {[[116, 222], [121.7, 226.1], [119.5, 232.9], [112.5, 232.9], [110.3, 226.1]].map(([x, y]) => (
      <circle key={`so${x}`} cx={x} cy={y} r="5" fill="#FFE8A3" stroke={INK} strokeWidth="4" />
    ))}
    {[[116, 222], [121.7, 226.1], [119.5, 232.9], [112.5, 232.9], [110.3, 226.1]].map(([x, y]) => (
      <circle key={`si${x}`} cx={x} cy={y} r="5" fill="#FFE8A3" />
    ))}
    <circle cx="116" cy="228" r="3" fill="#F08C00" />
  </>
);

const Eye = ({ cx, cy, rx, ry, glintX, glintY, glintR, dotX, dotY, dotR }) => (
  <>
    <ellipse cx={cx} cy={cy} rx={rx} ry={ry} fill="#2A0A0F" />
    <ellipse cx={cx} cy={cy + 7} rx={rx - 4} ry={ry - 9} fill="#8C2A36" />
    <circle cx={glintX} cy={glintY} r={glintR} fill="#FFFFFF" />
    <circle cx={dotX} cy={dotY} r={dotR} fill="#FFFFFF" />
  </>
);

// Mắt tròn + miệng chữ O, không kèm ngôi sao (announce dùng riêng phần này để khỏi đè lên tay "present")
const WowFace = () => (
  <>
    <circle cx="132" cy="148" r="17" fill="#FFFFFF" stroke={INK} strokeWidth="4" />
    <circle cx="134" cy="150" r="9" fill="#2A0A0F" />
    <circle cx="137" cy="146" r="3.5" fill="#FFFFFF" />
    <circle cx="200" cy="146" r="15" fill="#FFFFFF" stroke={INK} strokeWidth="4" />
    <circle cx="202" cy="148" r="8" fill="#2A0A0F" />
    <circle cx="205" cy="144" r="3" fill="#FFFFFF" />
    <path d="M114 120 Q128 109 144 115 M186 113 Q200 105 214 111" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" />
    <ellipse cx="168" cy="221" rx="9" ry="11" fill={INK} />
    <ellipse cx="168" cy="227" rx="5" ry="3" fill="#FF6B76" />
  </>
);

const Faces = {
  happy: () => (
    <>
      <Eye cx={132} cy={150} rx={12} ry={16} glintX={136} glintY={143} glintR={5} dotX={127} dotY={159} dotR={2.5} />
      <Eye cx={200} cy={147} rx={11} ry={15} glintX={204} glintY={141} glintR={4.5} dotX={196} dotY={156} dotR={2.2} />
      <path d="M118 126 Q128 119 141 123 M190 121 Q200 116 211 120" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" />
      <path d="M150 210 Q168 236 186 208 Z" fill={INK} stroke={INK} strokeWidth="3" strokeLinejoin="round" />
      <ellipse cx="169" cy="218" rx="7" ry="4" fill="#FF6B76" />
    </>
  ),
  laugh: () => (
    <>
      <path d="M118 154 Q132 136 146 154" fill="none" stroke="#2A0A0F" strokeWidth="6" strokeLinecap="round" />
      <path d="M188 150 Q200 134 212 150" fill="none" stroke="#2A0A0F" strokeWidth="6" strokeLinecap="round" />
      <path d="M146 208 Q168 246 192 206 Z" fill={INK} stroke={INK} strokeWidth="3" strokeLinejoin="round" />
      <ellipse cx="170" cy="220" rx="9" ry="5" fill="#FF6B76" />
      <path d="M250 70 Q253 80 263 83 Q253 86 250 96 Q247 86 237 83 Q247 80 250 70 Z" fill="#FFC53D" stroke={INK} strokeWidth="3" strokeLinejoin="round" />
    </>
  ),
  wink: () => (
    <>
      <Eye cx={132} cy={150} rx={12} ry={16} glintX={136} glintY={143} glintR={5} dotX={127} dotY={159} dotR={2.5} />
      <path d="M188 150 Q200 140 212 150" fill="none" stroke="#2A0A0F" strokeWidth="6" strokeLinecap="round" />
      <path d="M118 126 Q128 119 141 123 M190 128 Q200 124 211 128" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" />
      <path d="M162 214 Q163 230 171 230 Q179 230 180 214 Z" fill="#FF6B76" stroke={INK} strokeWidth="3" strokeLinejoin="round" />
      <path d="M150 210 Q168 222 186 208" fill="none" stroke={INK} strokeWidth="4.5" strokeLinecap="round" />
    </>
  ),
  wow: () => (
    <>
      <WowFace />
      <path d="M252 52 Q256 64 268 68 Q256 72 252 84 Q248 72 236 68 Q248 64 252 52 Z" fill="#FFC53D" stroke={INK} strokeWidth="3" strokeLinejoin="round" />
      <path d="M272 96 Q274 102 280 104 Q274 106 272 112 Q270 106 264 104 Q270 102 272 96 Z" fill="#FFC53D" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
    </>
  ),
  love: () => (
    <>
      <path d="M132 163 C117 152 114 138 124 135 C129 134 132 138 132 141 C132 138 135 134 140 135 C150 138 147 152 132 163 Z" fill="#D90429" stroke={INK} strokeWidth="3.5" strokeLinejoin="round" />
      <circle cx="125" cy="142" r="2.8" fill="#FFFFFF" />
      <path d="M200 158 C186 147 184 135 193 133 C197 132 200 135 200 138 C200 135 203 132 207 133 C216 135 214 147 200 158 Z" fill="#D90429" stroke={INK} strokeWidth="3.5" strokeLinejoin="round" />
      <circle cx="194" cy="139" r="2.5" fill="#FFFFFF" />
      <path d="M152 210 Q168 228 184 208 Z" fill={INK} stroke={INK} strokeWidth="3" strokeLinejoin="round" />
      <ellipse cx="168" cy="216" rx="6" ry="3.5" fill="#FF6B76" />
      <path d="M252 78 C242 70 241 61 247 59 C250 58 252 61 252 63 C252 61 254 58 257 59 C263 61 262 70 252 78 Z" fill="#FF5C8A" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M272 50 C266 45 265 39 269 38 C271 37 272 39 272 40 C272 39 273 37 275 38 C279 39 278 45 272 50 Z" fill="#FF5C8A" stroke={INK} strokeWidth="2" strokeLinejoin="round" />
    </>
  ),
  sad: () => (
    <>
      <ellipse cx="132" cy="152" rx="11" ry="13" fill="#2A0A0F" />
      <circle cx="135" cy="147" r="4" fill="#FFFFFF" />
      <ellipse cx="200" cy="149" rx="10" ry="12" fill="#2A0A0F" />
      <circle cx="203" cy="144" r="3.5" fill="#FFFFFF" />
      <path d="M118 130 L142 120 M188 118 L212 127" fill="none" stroke={INK} strokeWidth="4" strokeLinecap="round" />
      <path d="M124 166 Q117 179 124 183 Q131 179 124 166 Z" fill="#CFEFFF" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M154 222 Q168 210 182 222" fill="none" stroke={INK} strokeWidth="4.5" strokeLinecap="round" />
      <path d="M246 116 Q256 132 246 138 Q236 132 246 116 Z" fill="#CFEFFF" stroke={INK} strokeWidth="3" strokeLinejoin="round" />
    </>
  )
};

const Poses = {
  wave: () => (
    <>
      <Arm transform="translate(240 140) rotate(-58)" />
      <path d="M250 74 Q258 63 271 63 M291 84 Q298 94 294 106" fill="none" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
    </>
  ),
  phone: () => (
    <>
      <g transform="rotate(8 276 93)">
        <rect x="258" y="62" width="36" height="62" rx="9" fill="#2A0A0F" stroke={INK} strokeWidth="4" />
        <rect x="263" y="69" width="26" height="44" rx="4" fill="#FFFFFF" />
        <rect x="267" y="75" width="18" height="4" rx="2" fill="#FFC2C8" />
        <rect x="267" y="83" width="12" height="4" rx="2" fill="#FFC2C8" />
        <rect x="267" y="94" width="18" height="9" rx="4.5" fill="#D0011B" />
      </g>
      <Arm transform="translate(240 150) rotate(-38)" />
    </>
  ),
  bag: (bagT) => (
    <>
      <path d="M256 244 Q268 214 282 244" fill="none" stroke={INK} strokeWidth="4.5" strokeLinecap="round" />
      <g transform="rotate(4 268 260)">
        <rect x="246" y="238" width="46" height="44" rx="7" fill="#FFC53D" stroke={INK} strokeWidth="4.5" />
        <rect x="248" y="240" width="42" height="8" fill="#F59F00" />
        <text transform={bagT} x="269" y="275" textAnchor="middle" fontSize="24" fontWeight="800" fill="#D0011B" fontFamily={FONT}>%</text>
      </g>
      <Arm transform="translate(236 182) rotate(55)" />
    </>
  ),
  cheer: () => (
    <>
      <Arm transform="translate(238 138) rotate(-68)" />
      <Arm transform="translate(62 138) rotate(-112)" />
      <Coin cx={66} cy={36} r={12} big />
      <Coin cx={236} cy={24} r={10} big />
      <Coin cx={284} cy={60} r={8} />
      <Coin cx={18} cy={60} r={7} />
    </>
  ),
  present: () => (
    <>
      {/* Lớp bọc không có transform để CSS xoay tay quanh vai (240, 174) khi announce */}
      <g className="bo-arm-present">
        <Arm transform="translate(240 174) rotate(-28)" />
      </g>
      <path className="bo-tada" d="M272 124 l5 -10 M288 132 l8 -7" fill="none" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
    </>
  ),
  none: () => null
};

// Vòng tròn nền vẽ ngay trong SVG (không cần div bọc). Toạ độ theo viewBox 300
const HALOS = {
  pink: { cx: 150, cy: 146, r: 124, fill: 'var(--pop-pink, #ffdfe4)', stroke: 'var(--pop-ink, #1f1a19)' },
  paper: { cx: 150, cy: 143, r: 126, fill: 'var(--pop-paper, #fff4e4)', stroke: 'var(--pop-ink, #1f1a19)', dot: true },
  sun: { cx: 150, cy: 166, r: 118, fill: '#ffd84d', stroke: 'var(--apptour-ink, #2b1a1c)' }
};

const Bo = ({ mood = 'happy', faces, pose = 'wave', facing = 'right', size = 120, halo, decorative = true, announce = false, className, style }) => {
  const h = HALOS[halo];
  const sad = mood === 'sad';
  const left = facing === 'left';
  const Face = Faces[mood] || Faces.happy;
  const renderPose = Poses[pose] || Poses.none;
  const coinTextT = left ? 'translate(302 0) scale(-1 1)' : undefined;
  const a11y = decorative
    ? { 'aria-hidden': true, focusable: 'false' }
    : { role: 'img', 'aria-label': `Linh vật Bo, ${MOOD_LABELS[mood] || MOOD_LABELS.happy}` };

  return (
    <svg
      className={`bo${announce ? ' bo--announce' : ''}${className ? ` ${className}` : ''}`}
      viewBox="0 0 300 300"
      width={size}
      height={size}
      style={style}
      {...a11y}
    >
      {h && (
        <>
          <circle cx={h.cx} cy={h.cy} r={h.r} style={{ fill: h.fill, stroke: h.stroke }} strokeWidth="2" vectorEffect="non-scaling-stroke" />
          {h.dot && <circle cx="26" cy="63" r="15" style={{ fill: 'var(--pop-sun, #ffd23f)', stroke: h.stroke }} strokeWidth="2" vectorEffect="non-scaling-stroke" />}
        </>
      )}
      <ellipse className="bo-shadow" cx="152" cy="282" rx="100" ry="10" fill={INK} opacity="0.15" />
      {/* Lớp bọc không có transform: Bo.css nhún cả thân quanh chân (150, 282) */}
      <g className="bo-figure">
      <g transform={left ? 'translate(300 0) scale(-1 1)' : undefined}>
        {/* Đuôi xoăn. Lớp bo-tail, bo-ear-l/r (trái/phải khi facing right) để CSS bên ngoài vẫy, VD màn hình tải */}
        <g className="bo-tail">
          <path d="M46 172 C26 168 20 146 34 142 C46 139 47 155 36 156" fill="none" stroke={INK} strokeWidth="11" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M46 172 C26 168 20 146 34 142 C46 139 47 155 36 156" fill="none" stroke={BODY} strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>

        {/* Tai */}
        {sad ? (
          <>
            <g className="bo-ear-l">
              <path d="M84 100 Q44 84 34 110 Q50 128 100 112 Z" fill={BODY} stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
              <path d="M82 104 Q54 96 46 110 Q62 120 92 110 Z" fill="#FFB8C0" />
            </g>
            <g className="bo-ear-r">
              <path d="M214 98 Q252 80 264 104 Q250 124 206 112 Z" fill="#C9283A" stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
              <path d="M216 102 Q244 92 252 104 Q240 116 214 110 Z" fill="#FFB8C0" />
            </g>
          </>
        ) : (
          <>
            <g className="bo-ear-l">
              <path d="M78 108 Q58 52 86 38 Q114 50 130 84 Z" fill={BODY} stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
              <path d="M88 94 Q76 60 90 52 Q106 62 116 84 Z" fill="#FFB8C0" />
            </g>
            <g className="bo-ear-r">
              <path d="M180 86 Q196 44 226 42 Q240 76 228 106 Z" fill="#C9283A" stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
              <path d="M192 82 Q202 58 220 54 Q228 74 222 96 Z" fill="#FFB8C0" />
            </g>
          </>
        )}

        {/* Tay (vẽ sau thân để khớp vào hông) */}
        {renderPose(left ? 'translate(538 0) scale(-1 1)' : undefined)}

        {/* Chân */}
        <Leg x={92} />
        <Leg x={180} />

        {/* Thân */}
        <ellipse cx="150" cy="165" rx="108" ry="90" fill={BODY} />
        <path d="M251.5 134.2 A108 90 0 0 1 113.1 249.6 Q225 232 251.5 134.2 Z" fill="#C9283A" />
        <ellipse cx="98" cy="112" rx="26" ry="10" fill="#FF8790" transform="rotate(-32 98 112)" />
        <ellipse cx="82" cy="130" rx="7" ry="4" fill="#FFFFFF" opacity="0.9" transform="rotate(-32 82 130)" />
        <circle cx="122" cy="96" r="3" fill="#FFFFFF" opacity="0.9" />

        <Flower />
        <ellipse cx="150" cy="165" rx="108" ry="90" fill="none" stroke={INK} strokeWidth="5" />

        {/* Đồng xu và khe bỏ ống */}
        {!sad && (
          <g className="bo-coin-slot">
            <path d="M140.4 84 A24 24 0 1 1 159.6 84 Z" fill="#FFC53D" stroke={INK} strokeWidth="4.5" strokeLinejoin="round" />
            <circle cx="150" cy="62" r="16" fill="none" stroke="#F59F00" strokeWidth="3" />
            <path d="M137 57 Q140 47 150 44" fill="none" stroke="#FFF3C4" strokeWidth="4" strokeLinecap="round" />
            <text transform={coinTextT} x="151" y="71" textAnchor="middle" fontSize="24" fontWeight="800" fill="#A85A00" fontFamily={FONT}>đ</text>
          </g>
        )}
        {/* Đồng xu nguyên vẹn bật khỏi khe khi announce; vẽ trước khe để khe che phần đáy lúc nằm yên */}
        {announce && !sad && (
          <g className="bo-coin-fly">
            <circle cx="150" cy="62" r="24" fill="#FFC53D" stroke={INK} strokeWidth="4.5" />
            <circle cx="150" cy="62" r="16" fill="none" stroke="#F59F00" strokeWidth="3" />
            <path d="M137 57 Q140 47 150 44" fill="none" stroke="#FFF3C4" strokeWidth="4" strokeLinecap="round" />
            <text transform={coinTextT} x="151" y="71" textAnchor="middle" fontSize="24" fontWeight="800" fill="#A85A00" fontFamily={FONT}>đ</text>
          </g>
        )}
        <rect x="122" y="81" width="56" height="10" rx="5" fill={INK} />

        {/* Má hồng, mõm */}
        <ellipse cx="108" cy="178" rx="15" ry="9" fill="#FF9EAA" />
        <path d="M100 181 l4 -6 M107 182 l4 -6 M114 183 l4 -6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" opacity="0.85" />
        <ellipse cx="230" cy="172" rx="11" ry="8" fill="#FF9EAA" />
        <ellipse cx="168" cy="184" rx="30" ry="21" fill="#FF9AA5" stroke={INK} strokeWidth="4.5" transform="rotate(-6 168 184)" />
        <ellipse cx="160" cy="175" rx="10" ry="4" fill="#FFD1D6" transform="rotate(-6 160 175)" />
        <ellipse cx="158" cy="186" rx="4.5" ry="7" fill={INK} />
        <ellipse cx="179" cy="185" rx="4.5" ry="7" fill={INK} />

        {announce ? (
          <>
            <g className="bo-face-wow"><WowFace /></g>
            <g className="bo-face-final"><Face /></g>
          </>
        ) : faces ? (
          faces.map((m) => {
            const MoodFace = Faces[m] || Faces.happy;
            return <g key={m} className={`bo-face--${m}`}><MoodFace /></g>;
          })
        ) : (
          <Face />
        )}
      </g>
      </g>
    </svg>
  );
};

export default Bo;
